module.exports = __webpack_public_path__ + "img/services-alb1.9afdae61.svg";